import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { ProductPricingsDto } from "../../../../dtos/documents/ProductPricings/ProductPricingsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { ProductPricingsModel } from "../../../../models/Documents/ProductPricings/ProductPricingsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import ProductPricingsDetailSkeleton from "./ProductPricingsDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { ProductPricingsDetailFooter } from "./ProductPricingsDetailFooter";
interface IProps {
  model: ProductPricingsDto | null;
  modelUpdatedEvent: (newModel: ProductPricingsDto) => void;
}

export const ProductPricingsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ProductPricingsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Product Pricings");

  const watchProducts = watch("productPricingGoods");

  useEffect(() => {
    // console.log(model);
    register("productPricingGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("createdDate", model.createdDate);
      setValue("productPricingGoods", model.productPricingGoods);
    }
  }, [model]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: ProductPricingsModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: ProductPricingsDto = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ProductPricingsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    setValue(`productPricingGoods.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    setValue(`productPricingGoods.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  if (!model) {
    return (
      <>
        <ProductPricingsDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.ProductPricings.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"productPricingGoods"}>
            <NFLookupUnit title="unit" fieldName="unitId" width={200} />
            <NFLookupProduct fieldName={"productId"} title={"product"} width={200} />
            <NFIntInput fieldName={"oldPrice"} title={"Old price"} width={100} />
            <NFIntInput fieldName={"newPrice"} title={"New price"} width={100} />
            <NFIntInput fieldName={"pecent"} title={"Percent"} width={100} />
            <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} onValueChanged={handleQuantityChanged} />
            <NFIntInput fieldName={"price"} title={"Price"} width={100} onValueChanged={handlePriceChanged} />
            <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <ProductPricingsDetailFooter/>
    </FormProvider>
  );
};
